/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import RepInfo from "@eisinc/App/Components/RepInfo/RepInfo";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { RfqConfirmationPageContext } from "@insite/content-library/Pages/RfqConfirmationPage";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainer, GridItem } from "@insite/mobius/index";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqConfirmation.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqConfirmationDetailsRepInfoStyles {
    repInfoGrid: GridItemProps;
}

const styles: RfqConfirmationDetailsRepInfoStyles = {
    repInfoGrid: {
        width: [12, 6, 6, 6, 6],
        printWidth: 12,
        css: css`
            @media print {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
};

const RfqConfirmationDetailsRepInfo: FC<Props> = ({ quoteState }) => {
    const quote = quoteState.value;
    const primarySales = (quote && quote.properties && quote.properties.primarySalesRep) || "";
    const secondarySales = (quote && quote.properties && quote.properties.secondarySalesRep) || "";
    const billTo = quote && quote.billTo;

    if (!quote || (!primarySales && !secondarySales)) {
        return null;
    }

    return (
        <GridContainer>
            <GridItem {...styles.repInfoGrid}>
                <RepInfo
                    salesPersonData={secondarySales}
                    clickable={true}
                    title={translate("Inside Sales Reps")}
                    billTo={billTo}
                />
            </GridItem>
            <GridItem {...styles.repInfoGrid}>
                <RepInfo
                    salesPersonData={primarySales}
                    clickable={true}
                    chat={true}
                    title={translate("Outside Sales Reps")}
                    billTo={billTo}
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqConfirmationDetailsRepInfo),
    definition: {
        displayName: "Rfq Confirmation Rep Info",
        allowedContexts: [RfqConfirmationPageContext],
        fieldDefinitions: [],
        group: "RFQ Quote Confirmation",
    },
};

export default widgetModule;
